import React from 'react';
import { Route, Switch } from "react-router-dom";

import Main from '../pages/Main';
import VideoInner from '../pages/VideoInner';
import SignIn from '../pages/SignIn';
import NotFound from '../pages/NotFound';

function RoutGroup() {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />
      <Route path="/video-list/" exact component={Main} />
      <Route path="/video/" component={VideoInner} />
      <Route component={NotFound} />
    </Switch> 
  )
}

export default RoutGroup;
